import { render, staticRenderFns } from "./ProductIntroduction.vue?vue&type=template&id=6c77015b&scoped=true&"
import script from "./ProductIntroduction.vue?vue&type=script&lang=js&"
export * from "./ProductIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./ProductIntroduction.vue?vue&type=style&index=0&id=6c77015b&lang=less&scoped=true&"
import style1 from "./ProductIntroduction.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c77015b",
  null
  
)

export default component.exports